// extracted by mini-css-extract-plugin
module.exports = {"container":"collapse-module__container___YGYdc","content":"collapse-module__content___3fBrM"};